import get from 'lodash.get';

import cottonFlagManager from './featureFlags/cotton';
import { kibanaLog } from './logger';

// Check if any error in the errors array has the specified error code
const hasErrorCode = (cottonError, errorCode) => {
  const errors = get(cottonError, 'data.error', []);
  return Array.isArray(errors) && errors.some(error => error?.errorCode === errorCode);
};

// Generic function to handle Cotton API calls with Ruby fallback
export const callApiWithFallback = async (
  dispatch,
  cottonApiCall,
  rubyApiCall,
  apiName,
) => {
  try {
    // Attempt to call Cotton API and wait for the response
    return await dispatch(cottonApiCall()).payload;
  } catch (cottonError) {
    // Do not fallback to Ruby API if we have expected error codes or Ruby APIs are disabled
    if (
      cottonFlagManager.disableRubyApis
      || get(cottonError, 'data.code') === 'SH404.127.2'
      || get(cottonError, 'data.code') === 'SH400.20'
      || hasErrorCode(cottonError, 'BOM001') // BOM001: Invalid value for programName
      || hasErrorCode(cottonError, 'BOM059') // BOM059: Account not eligible for swap (devices/swap/order endpoint)
      || hasErrorCode(cottonError, 'BOM2307') // BOM2307: Unable to process telemetry order
    ) {
      throw cottonError;
    }
    try {
      // Attempt to call Ruby API and wait for the response
      const result = await dispatch(rubyApiCall()).payload;
      kibanaLog(`ruby_${apiName}_fallback_success`);
      return result;
    } catch (error) {
      kibanaLog(`ruby_${apiName}_fallback_error`);
      throw error;
    }
  }
};

export default callApiWithFallback;
